import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './Login/Login.component';
import { ReportComponent } from './Report/Report.component';
import { IndexComponent } from './Index/Index.component';
import { authGuard } from './auth.guard';

const routes: Routes = [
  { path: '', component: IndexComponent},
  { path: 'report', component: ReportComponent, canActivate: [authGuard] }

]
@NgModule({
  // SECURITY: enableTracing disabled — it leaks full navigation details to the console in production.
  imports: [RouterModule.forRoot(routes,  { enableTracing: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
